import "bootstrap-icons/font/bootstrap-icons.css";

import { Col, Row } from "react-bootstrap";
import parse from "html-react-parser";

import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";
import { eligibility } from "constants/eligibility";
import ScrollAnimatedProgressBar from "components/progressbar/ScrollAnimatedProgressBar";

import outline_check from "assets/images/outline_check.svg";

function Deposit() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Treasury"
          title={`
              <span className="jumbotron-subtitle-2">
                Deposits
              </span>`}
          buttonText="Reach out to us!"
          // footNotes="Protected by PIDM up to RM250,000 for each depositor"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              At alrajhi bank Malaysia, we offer you deposit arrangement via
              Commodity Murabahah transactions both in Ringgit and other foreign
              currencies. The commodities offered are regulated and traded
              either at the London Metal Exchange or Bursa Malaysia trading
              platforms, both of which are secure and convenient to access.
            </p>
            {/* <img
              style={{ width: "100%" }}
              src={currency}
              className="d-inline-block align-top"
              alt=""
            /> */}
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Our Products</h3>
          </div>
          <div className="col-xl-8">
            <p>
              <b>Commodity Deferred Purchase Agreement</b>
            </p>
            <p>
              <li>
                Commodity Deferred Purchase Agreement (CDPA) is a Shariah
                compliant term deposit product which allows Treasury clients
                make placement with the Bank via commodity trading arrangement
                whereby specific commodities of Shariah compliant are used as
                underlying assets for sale and purchase transactions.
              </li>
            </p>
            <p>
              <li>
                The Client will be able to generate periodical returns with
                their excess funds and mainly used to meet short term
                requirement. The profit rate is made known upfront and agreed by
                all parties involved.
              </li>
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Flexible Tenure</div>
                <div className="column-subheader-2">
                  Preferably one month minimum placement or as agreed by both
                  parties{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Guaranteed Principle</div>
                <div className="column-subheader-2">
                  With fixed rate of return{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <Row>
          <Col md={4}>
            <h3>Requirements</h3>
          </Col>
          <Col md={8}>
              <ScrollAnimatedProgressBar data={eligibility}>
                {eligibility.points.requirementdeposit.description.map(
                  (benefit, index) => (
                    <div className="animated-list z-1">
                      <div className="check">
                        <img src={outline_check} width="22" alt="outline_check" />
                      </div>
                      <div
                        data-aos="zoom-in-down"
                        data-aos-delay={`${index + 1}00`}
                      >
                        {parse(benefit)}
                      </div>
                    </div>
                  )
                )}
              </ScrollAnimatedProgressBar>
          </Col>
        </Row>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Deposit;
